import {
    IntroModalCloseButtonStyled,
    IntroModalContentStyled,
    IntroModalInnerWrapperStyled,
    IntroModalLeftContainer,
    IntroModalWatchLaterFooterStyled,
} from './styled/TutorialsStyled';
import { Button } from 'react-bootstrap';
import { VideoPlayButton } from './components/VideoPlayButton/VideoPlayButton';
import { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { setIsFirstShowIntro, showWatchMoreVideosLaterTooltipAction } from './tutorialsActions';
import { createStructuredSelector } from 'reselect';
import { getIsFirstShowIntro } from './tutorialsSelectors';
import { BinIcon } from '../../components/icon/Icon';
import { useIntroModalContentEvents, useIntroModalGTMEvents } from "./tutorialsHooks";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

const IntroModal = ({
    closeModal,
    isFirstShowIntro,
    showWatchMoreVideosLaterTooltip,
    setIsFirstShowIntro,
}) => {
    const {getLangPath} = useLangContext();
    const {handleSendIsPlayedIntroVideoGTMEvent} = useIntroModalGTMEvents(isFirstShowIntro);
    const tutorialLink = useMemo(() => getLangPath('video_tutorial.link'), [getLangPath]);

    const {
        isContentClicked,
        isContentHovered,
        handleContentClick,
        handleContentMouseEnter,
        handleContentMouseLeave,
    } = useIntroModalContentEvents({
        onContentClick: () => handleSendIsPlayedIntroVideoGTMEvent(true),
    })

    useEffect(() => {
        if (!tutorialLink) {
            closeModal();
            return;
        }
        return () => {
            if (isFirstShowIntro) {
                showWatchMoreVideosLaterTooltip(true);
                setIsFirstShowIntro(false);
            }
        }
    }, [closeModal, isFirstShowIntro, setIsFirstShowIntro, showWatchMoreVideosLaterTooltip, tutorialLink]);

    return (
            <div className="position-relative">
                <IntroModalContentStyled
                        onClick={handleContentClick}
                        onMouseEnter={handleContentMouseEnter}
                        onMouseLeave={handleContentMouseLeave}
                >
                    {!isContentClicked ? (
                            <>
                                <IntroModalInnerWrapperStyled>
                                    <IntroModalLeftContainer>
                                        <VideoPlayButton hover={isContentHovered}/>
                                    </IntroModalLeftContainer>
                                    <div>
                                        <h1>{getLangPath('video_tutorial.title')}</h1>
                                        <p>{getLangPath('video_tutorial.intro.description')}</p>
                                    </div>
                                </IntroModalInnerWrapperStyled>
                            </>
                    ) : (
                            <iframe
                                    width="100%"
                                    height="100%"
                                    src={`${getLangPath('video_tutorial.link')}?autoplay=1`}
                                    title="Intro Modal"
                                    frameBorder="0"
                                    allow="autoplay"
                                    allowFullScreen
                            />
                    )}
                </IntroModalContentStyled>
                {isFirstShowIntro && (
                        <IntroModalWatchLaterFooterStyled>
                            <p>
                                {getLangPath('video_tutorial.watch_later.description')}
                            </p>
                            <Button
                                    onClick={closeModal}
                                    variant={'info'}
                                    size={'md'}
                                    style={{flex: '0 0 auto', marginLeft: '32px'}}
                            >
                                {getLangPath('video_tutorial.watch_later.button')}
                            </Button>
                        </IntroModalWatchLaterFooterStyled>
                )}
                <IntroModalCloseButtonStyled onClick={closeModal}>
                    <BinIcon name="IcXMarkThin" style={{fontSize: '40px'}}/>
                </IntroModalCloseButtonStyled>
            </div>
    );
};

const mapStateToProps = createStructuredSelector({
    isFirstShowIntro: getIsFirstShowIntro,
});

const mapDispatchToProps = (dispatch) => ({
    showWatchMoreVideosLaterTooltip: (payload) => dispatch(showWatchMoreVideosLaterTooltipAction(payload)),
    setIsFirstShowIntro: (payload) => dispatch(setIsFirstShowIntro(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IntroModal);
